import LogRocket from "logrocket";

const devCheck = () => {
	console.log(window.location);
	return true;
};

const log = (data, string = null) => {
	if (devCheck) {
		console.log(window.location);
		if (string) return console.log(string + " console.log", data);
		return console.log(data);
	} else {
		if (string) return LogRocket.log(string, data);
		return LogRocket.log(data);
	}
};
const error = (data, string = null) => {
	if (devCheck) {
		if (string) return console.error(string, data);
		return console.error(data);
	} else {
		if (string) return LogRocket.error(string, data);
		return LogRocket.error(data);
	}
};

export { log, error };
